import { Link } from 'react-router-dom';

const articles = [
  {
    slug: '/sugargoo-review-2026',
    title: 'Sugargoo Review 2026',
    description: 'Honest platform analysis after extensive use. Pricing, QC quality, shipping speed, and overall value rated.',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20review%20setup%20with%20a%20laptop%20displaying%20shopping%20platform%20analytics%20alongside%20neatly%20arranged%20fashion%20items%20on%20a%20clean%20oak%20desk%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20and%20muted%20sage%20tones%2C%20editorial%20tech%20review%20photography%2C%20thoughtful%20and%20analytical%20atmosphere&width=800&height=560&seq=article-card-review&orientation=landscape',
    category: 'Review',
  },
  {
    slug: '/sugargoo-shipping-cost-guide',
    title: 'Shipping Cost Guide',
    description: 'Complete international shipping cost breakdown. Compare carriers, consolidation strategies, and hidden fee avoidance.',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20cardboard%20shipping%20boxes%20of%20various%20sizes%20with%20international%20labels%20and%20packing%20tape%20arranged%20on%20a%20light%20wood%20floor%2C%20soft%20afternoon%20sunlight%2C%20organized%20logistics%20aesthetic%2C%20warm%20kraft%20brown%20and%20cream%20tones%2C%20professional%20e-commerce%20packaging%20photography%2C%20neat%20and%20systematic%20composition&width=800&height=560&seq=article-card-shipping&orientation=landscape',
    category: 'Guide',
  },
  {
    slug: '/sugargoo-coupon-discount-guide',
    title: 'Coupon & Discount Codes',
    description: 'Find and apply active Sugargoo coupons. Track seasonal sales, platform events, and maximize every purchase.',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20tags%20and%20promotional%20cards%20with%20golden%20confetti%20arranged%20on%20a%20warm%20terracotta%20surface%2C%20soft%20golden%20hour%20lighting%20from%20the%20side%2C%20celebration%20and%20savings%20aesthetic%2C%20rich%20amber%20and%20dusty%20rose%20tones%2C%20elegant%20promotional%20lifestyle%20photography%2C%20festive%20and%20inviting%20mood&width=800&height=560&seq=article-card-coupon&orientation=landscape',
    category: 'Savings',
  },
  {
    slug: '/sugargoo-warehouse-guide',
    title: 'Warehouse Guide',
    description: 'Master Sugargoo warehouse storage, QC photography, and consolidation. Save 40-60% on shipping with smart haul building.',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20fashion%20packages%20and%20clothing%20items%20on%20industrial%20shelving%20with%20natural%20light%20streaming%20through%20frosted%20windows%2C%20clean%20minimalist%20warehouse%20aesthetic%2C%20warm%20white%20and%20soft%20gray%20tones%2C%20professional%20logistics%20and%20storage%20photography%2C%20orderly%20systematic%20composition&width=800&height=560&seq=article-card-warehouse&orientation=landscape',
    category: 'Guide',
  },
  {
    slug: '/is-sugargoo-legit',
    title: 'Is Sugargoo Legit?',
    description: 'Complete safety and trust analysis. Payment security, buyer protection, community trust signals and scam prevention.',
    image: 'https://readdy.ai/api/search-image?query=A%20shield%20symbol%20graphic%20displayed%20on%20a%20tablet%20screen%20beside%20verified%20checkmark%20icons%20and%20neatly%20displayed%20fashion%20accessories%20on%20a%20clean%20white%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20trust%20and%20security%20aesthetic%2C%20calm%20sage%20green%20and%20cream%20tones%2C%20professional%20corporate%20trust%20photography&width=800&height=560&seq=article-card-legit&orientation=landscape',
    category: 'Trust',
  },
  {
    slug: '/sugargoo-spreadsheet-beginners',
    title: 'Beginner Step-by-Step Guide',
    description: 'Your first Sugargoo order from start to finish. Account setup, product browsing, ordering, QC review, and shipping.',
    image: 'https://readdy.ai/api/search-image?query=A%20welcoming%20learning%20scene%20with%20an%20open%20notebook%20showing%20numbered%20shopping%20steps%20beside%20a%20laptop%20and%20a%20warm%20cup%20of%20coffee%2C%20soft%20morning%20sunlight%20through%20sheer%20curtains%2C%20friendly%20and%20approachable%20aesthetic%2C%20warm%20beige%20and%20soft%20blush%20tones%2C%20cozy%20lifestyle%20photography%2C%20encouraging%20and%20supportive%20atmosphere&width=800&height=560&seq=article-card-beginner&orientation=landscape',
    category: 'Tutorial',
  },
  {
    slug: '/sugargoo-spreadsheet-shoes-finds',
    title: 'Best Shoes Finds',
    description: 'Top sneaker and footwear discoveries in the Sugargoo Spreadsheet. Sizing tips, price expectations, and trend tracking.',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20sneaker%20collection%20display%20with%20three%20pairs%20of%20trendy%20footwear%20arranged%20on%20minimalist%20white%20pedestals%2C%20soft%20directional%20studio%20lighting%20creating%20elegant%20shadows%2C%20modern%20sneaker%20culture%20aesthetic%2C%20warm%20terracotta%20and%20cream%20tones%2C%20premium%20footwear%20editorial%20photography%2C%20artistic%20composition&width=800&height=560&seq=article-card-shoes&orientation=landscape',
    category: 'Finds',
  },
  {
    slug: '/sugargoo-vs-alternatives',
    title: 'Sugargoo vs Alternatives',
    description: 'Compare Sugargoo against Pandabuy, CSSBuy, Superbuy and more. Feature-by-feature analysis to find your best fit.',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20smartphone%20screens%20displaying%20different%20shopping%20app%20interfaces%20arranged%20side%20by%20side%20on%20a%20clean%20white%20marble%20desk%2C%20soft%20balanced%20studio%20lighting%2C%20tech%20comparison%20aesthetic%2C%20clean%20warm%20gray%20and%20white%20tones%2C%20professional%20review%20photography%2C%20balanced%20and%20objective%20composition&width=800&height=560&seq=article-card-alternatives&orientation=landscape',
    category: 'Comparison',
  },
  {
    slug: '/sugargoo-qc-photos-guide',
    title: 'QC Photos Pro Guide',
    description: 'Master quality control photography inspection. Spot issues before shipping, request better photos, and never get a bad item.',
    image: 'https://readdy.ai/api/search-image?query=A%20camera%20with%20macro%20lens%20aimed%20at%20fashion%20product%20details%20on%20a%20clean%20inspection%20table%2C%20magnifying%20glass%20and%20measuring%20tools%20nearby%2C%20soft%20professional%20studio%20lighting%2C%20meticulous%20quality%20control%20aesthetic%2C%20clean%20white%20and%20cool%20gray%20tones%2C%20professional%20inspection%20photography%2C%20precise%20and%20detailed%20composition&width=800&height=560&seq=article-card-qc&orientation=landscape',
    category: 'Guide',
  },
];

export default function ArticlesShowcaseSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100" id="articles">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900">
            Sugargoo Spreadsheet Guides & Resources
          </h2>
          <p className="mt-3 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Explore our collection of in-depth SEO guides covering every aspect of Sugargoo shopping — from reviews and cost analysis to beginner tutorials and pro strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-200 hover:translate-y-[-2px]"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {article.description}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}